import chevron from "../../../Images/work-side.png";
import Cookies from 'js-cookie'
import { useEffect, useState } from "react";
import { useCreateWorksheetMutation } from "@/App/services/worksheetApiSlice";
import { BiLoaderAlt } from "react-icons/bi";
import { toast } from "sonner";

function Summary({ handleCancel, nextStep }) {
  const [worksheet, setWorkSheet] = useState(null)
  const [client, setClient] = useState(null)
  const [ createWorksheet, { isLoading } ] = useCreateWorksheetMutation();
  
  async function submit () {
    try {
      const data = {
        ...worksheet, 
        user_id: client?.id 
      }
      const saveWorksheet = await createWorksheet(data).unwrap();
      console.log(saveWorksheet);
      if (saveWorksheet?.success) {
        toast.success(saveWorksheet.message);
        handleCancel();
      }
    } catch (error) {
      toast.error(error?.data?.message)
      console.log(error)
    } 
  }
  function handleEditClient() {
    nextStep(2);
  }
  function handleEditQuestions() {
    nextStep(1);
  }

  useEffect(() => {
    setWorkSheet(JSON.parse(Cookies.get('worksheet')))
    setClient(JSON.parse(Cookies.get('client')))
  }, [])

  return (
    <div className="relative w-full min-h-full">
      <div className="bg-white h-[55px] border-b border-[#ECECED] duo:h-[64px] z-10 flex justify-end tablet:justify-between items-center px-[5vw]  w-full sticky top-0">
        <h3 className="text-[#0A0D14] hidden tablet:inline text-base font-semibold">
          Create Worksheet
        </h3>
        <div className="flex justify-center items-center gap-3">
          <button
            onClick={handleCancel}
            className="border border-[#E2E4E9] text-sm font-medium py-2 duo:py-[10px] text-center px-4 rounded-[50px] text-[#525866]"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isLoading}
            onClick={submit}
            className="flex bg-[#1A6A73] justify-center items-center gap-3 text-sm font-medium py-2 duo:py-[10px] text-center px-4 rounded-[50px] text-white"
          >
            <p>Create Worksheet</p>
            {isLoading ? <BiLoaderAlt className="text-[24px] animate-spin" /> : 
            <img src={chevron} alt="chevron" />}
          </button>
        </div>
      </div>
      <div className="mb-8 mt-11">
        <div className=" w-[90vw]  max-w-[638px] mx-auto ">
          <div className="w-full space-y-4 border-[#E2E4E9] border p-4 duo:p-6 bg-white rounded-[16px]">
            <div className="flex  justify-between items-center ">
              <div className="flex justify-start gap-3 items-center ">
                <img className="w-10" src={client?.avatar} alt="avatar" />
                <div>
                  <h2 className="text-[#0A0D14] capitalize font-medium text-base ">
                    {client?.name}
                  </h2>
                  <p className="text-[#525866] text-sm  ">{client?.email}</p>
                </div>
              </div>
              <button
                onClick={handleEditClient}
                className=" text-[#1A6A73] font-medium text-sm"
              >
                Edit
              </button>
            </div>
          </div>
          <div className="w-full space-y-4 mt-6 border-[#E2E4E9] border p-4 duo:p-6 bg-white rounded-[16px]">
            <div className="space-y-3">
              <div className="w-full flex justify-end">
                <button
                  onClick={handleEditQuestions}
                  className=" text-[#1A6A73] font-medium text-sm"
                >
                  Edit
                </button>
              </div>
              <div className="space-y-4">
                <h2 className="text-[#0A0D14] font-semibold text-lg leading-[22px]">
                  {worksheet?.title}
                </h2>
                <p className="text-sm text-[#525866]">
                  {worksheet?.description}
                </p>
              </div>
            </div>
          </div>
          <div className="w-full space-y-4 mt-6 border-[#E2E4E9] border p-4 duo:p-6 bg-white rounded-[16px]">
            <div className="">
              {worksheet?.type === 'registration-form' && <><div className="w-full flex justify-between">
                <h2 className="text-base font-medium text-[#0A0D14] ">
                  Worksheet Questions
                </h2>
                <button
                  onClick={handleEditQuestions}
                  className=" text-[#1A6A73] font-medium text-sm"
                >
                  Edit
                </button>
              </div>
              <div className="space-y-4 mt-4">
                {worksheet?.questions.map((item, index) => (
                  <div key={index} className="flex gap-[10px] justify-start items-start">
                    <span className="text-base leading-[22px] text-[#0A0D14] font-medium">
                      {index + 1}.
                    </span>
                    <p className="text-[#0A0D14] text-sm ">
                      {item}
                    </p>
                  </div>
                ))}
              </div></>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Summary;
